import { createSelector } from 'reselect';

/**
 * Get pending.
 *
 * @author Ihar Kazlouski
 * @function getPending
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {boolean} pending.
 */
var getPending = function getPending(state) {
  return state.auth.pending;
};
/**
 * Get user.
 *
 * @author Ihar Kazlouski
 * @function getUser
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {User | null} current user.
 */


var getUser = function getUser(state) {
  return state.auth.user;
};
/**
 * Get user.
 *
 * @author Ihar Kazlouski
 * @function getRoles
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {User | null} current user roles.
 */


var getRoles = function getRoles(state) {
  return state.auth.roles;
};
/**
 * Get error.
 *
 * @author Ihar Kazlouski
 * @function getError
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {string | null} error.
 */


var getError = function getError(state) {
  return state.auth.error;
};
/**
 * Get auth.
 *
 * @author Ihar Kazlouski
 * @function getAuth
 * @category Selectors
 * @subcategory Auth
 * @param {AppState} state state.
 * @return {AuthUser | null} error.
 */


var getAuth = function getAuth(state) {
  return {};
};

export var getUserSelector = createSelector(getUser, function (user) {
  return user;
});
export var getRolesSelector = createSelector(getRoles, function (roles) {
  return roles;
});
export var getPendingSelector = createSelector(getPending, function (pending) {
  return pending;
});
export var getErrorSelector = createSelector(getError, function (error) {
  return error;
});
export var getAuthSelector = createSelector(getAuth, function (auth) {
  return auth;
});